// Generates a table displaying all rate schedule groups.
// We can extend this to show all rate schedule groups within an industry or group
// but that can come later.

class RateScheduleGroupsManagement extends HTMLElement{
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = `<div>
                        <div class="row">
                          <div class="col-sm-12" style="display:flex; justify-content: space-between; margin-bottom: 10px;">
                            <h3>Rate Schedule Collection</h3>
                            <a class="btn btn-primary pull-right" data-turbolinks="false" href="/admin/rate_schedule_groups/new">Add New Collection</a>

                          </div>  
                        </div>
                      </div>
                      
                      <table id="all_audio" class="table vertical-middle" style="width:100%">
                          <tfoot style="display: table-header-group;">
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                              </tr>
                          </tfoot>
                          <thead>
                              <tr>
                                <th></th>
                                <th>Collection Name</th>
                                <th>Active</th>
                                <th>No. Rate Schedules</th>
                                <th>No. of Industries</th>
                                <th>No. of Groups</th>
                                <th>Actions</th>
                              </tr>
                          </thead>
                      </table>`;

    this.init();
  }
                    
  init() {
    this.table = $('#all_audio').DataTable({
      "ajax": "/admin/rate_schedule_groups/index_data",
      "columns": [
        {
          "class": "details-control",
          "orderable": false,
          "data": null,
          "defaultContent": ""
        },
        { "data": "name" },
        { data : "rate_schedule_collection_is_active", "visible" : true, "searchable":false, "orderable":true,
          render: function ( data, type, row ) {
                  var clazz = (row.rate_schedule_collection_is_active) ? 'glyphiconyes glyphicon-ok' : 'glyphiconno glyphicon-remove' ;
                  return ( type === 'display') ? `<i class='${clazz}'></i>` : data;
                }, "class":"text-center"
        },

        { "data": "number_of_rate_schedules", "class":"text-center" },
        { "data": "number_of_industries", "class":"text-center" },
        { "data": "number_of_autogroups", "class":"text-center" },
        { data : "domain_id", "visible" : true, "searchable":false, "orderable":false,  
          render: function ( data, type, row ) {
                    let html = `<a data-turbolinks="false" href="/admin/rate_schedule_groups/${row.rate_schedule_group_id}/edit">Edit</a> | `
                    html += `<a disabled data-confirm="Really delete rate schedule group '${row.name}'" rel="nofollow" data-method="delete" href="/admin/rate_schedule_groups/${data}">Delete</a>`

                    return html;
                }, "class":"text-center"
        }

      ],
      initComplete: function () {
          
      },
      "order": [[1, 'asc']]
    });
    this.table.on('draw', function () {
      $.each(detailRows, function (i, id) {
        $('#' + id + ' td.details-control').trigger('click');
      });
    });

    let detailRows = [];

    $('#all_audio tbody').on('click', 'tr td.details-control', async function (e) {
      let tr = $(e.target).closest('tr');
      let row = this.table.row(tr);
      let idx = $.inArray(tr.attr('id'), detailRows);

      if (row.child.isShown()) {
        tr.removeClass('details shown');
        row.child.hide();

        detailRows.splice(idx, 1);
      }
      else {
        let oldSelectedTr = $("table#all_audio tr.shown");
            if(oldSelectedTr.size() > 0) {
              let oldSelectedRow = this.table.row(oldSelectedTr);
              oldSelectedTr.next('tr').removeClass('details-row');
              oldSelectedRow.child.hide();
              oldSelectedTr.removeClass('shown');
            }
        tr.addClass('details shown');

        // Create component that will handle the rendering of the 
        // associated rate schedules for the selected rate schedule group.
        let row_detail = document.createElement("rate-schedule-groups-management-detail-row");
        row_detail.rateScheduleGroupId = row.data().rate_schedule_group_id;

        // // Get rate schedules associated with a rate schedule group
        // let groups = await fetch(`/admin/rate_schedule_groups/${row_detail.id}/rate_schedules`);
        // let audio_ids = await groups.json();
        // row_detail.current_selected_groups = audio_ids.map(group => group.group_id);

        // row_detail.url = `/admin/target_audio/${row_detail.id}/audio_items`;
        row.child(row_detail).show();

        if (idx === -1) {
          detailRows.push(tr.attr('id'));
        }
      }
    }.bind(this));
  }

  reloadData() {
    this.table.ajax.reload();
  }
}

customElements.define("rate-schedule-groups-management", RateScheduleGroupsManagement)